import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotVideoOff = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M6.394 24.594c.742 3.196 1.607 7.252 3.878 8.798 2.297 1.572 6.028.66 8.778-1.118 2.75-1.753 4.519-4.348 6.69-6.429 2.17-2.08 4.768-3.621 6.617-6.14 1.823-2.49 2.924-5.933 2.719-9.584-.205-3.651-1.717-7.51-4.7-8.207-2.982-.67-7.41 1.795-10.774 2.778-3.39.982-5.666.48-9.11.185C7.05 4.58 2.466 4.492 1.258 6.5c-1.21 1.983.932 6.064 2.351 9.273 1.395 3.235 2.016 5.598 2.786 8.82Z"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M17.968 8.333h5.061c.804 0 1.575.351 2.143.977a3.51 3.51 0 0 1 .887 2.356v5.567l1.515 1.667 9.091-7.233v16.666M4.165 2.5l31.667 35M26.06 26.666v1.667a3.51 3.51 0 0 1-.887 2.357c-.569.625-1.34.976-2.143.976H6.362c-.803 0-1.574-.35-2.142-.976a3.51 3.51 0 0 1-.888-2.357V11.667c0-.884.32-1.732.888-2.357.568-.626 1.339-.977 2.142-.977h3.03L26.06 26.667Z"
        />
    </SVG>
);
SpotVideoOff.displayName = "SpotVideoOff";
